import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, FileText, Gift } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    title: 'El Horario de Sueño Inverso',
    desc: 'La clave para dormir 6+ horas desde la primera noche.'
  }, {
    title: "El Mapa de Geometría 'Cero Fugas'",
    desc: 'Cómo eliminar los accidentes en interiores para siempre.'
  }, {
    title: 'Técnica Luz Roja/Luz Verde',
    desc: 'El fin de las mordidas dolorosas en manos y tobillos.'
  }];
  const bonuses = [{
    title: 'Hoja de Emergencia S.O.S.',
    desc: 'Para la nevera (Instrucciones visuales rápidas).'
  }, {
    title: 'Tracker de Progreso de 48 Horas',
    desc: 'Para medir resultados en tiempo real.'
  }];
  return <Section bg="white" data-id="element-202">
      <div className="text-center mb-16" data-id="element-203">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-204">
          Lo que obtienes hoy
        </h2>
        <p className="text-xl text-navy/70" data-id="element-205">
          El Protocolo del Hogar Silencioso (PDF de Implementación Inmediata)
        </p>
      </div>

      <div className="grid md:grid-cols-5 gap-8 max-w-5xl mx-auto" data-id="element-206">
        <div className="md:col-span-3 space-y-6" data-id="element-207">
          <div className="bg-cream p-8 rounded-2xl border border-cream-dark" data-id="element-208">
            <h3 className="text-2xl font-bold text-navy mb-6 flex items-center gap-3" data-id="element-209">
              <FileText className="text-amber w-6 h-6" data-id="element-210" />
              El Protocolo Principal
            </h3>
            <ul className="space-y-6" data-id="element-211">
              {deliverables.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-212">
                  <CheckCircle2 className="w-6 h-6 text-navy shrink-0 mt-1" data-id="element-213" />
                  <div data-id="element-214">
                    <strong className="block text-lg text-navy mb-1" data-id="element-215">
                      {item.title}
                    </strong>
                    <span className="text-navy/70" data-id="element-216">{item.desc}</span>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="md:col-span-2 space-y-6" data-id="element-217">
          <div className="bg-navy text-white p-8 rounded-2xl relative overflow-hidden h-full" data-id="element-218">
            <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-219">
              <Gift className="w-32 h-32" data-id="element-220" />
            </div>
            <div className="relative z-10" data-id="element-221">
              <h3 className="text-2xl font-bold text-amber mb-6 flex items-center gap-3" data-id="element-222">
                <Gift className="w-6 h-6" data-id="element-223" />
                Bonos Exclusivos
              </h3>
              <ul className="space-y-6" data-id="element-224">
                {bonuses.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-225">
                    <div className="w-6 h-6 rounded-full bg-amber/20 flex items-center justify-center shrink-0 mt-1" data-id="element-226">
                      <div className="w-2 h-2 bg-amber rounded-full" data-id="element-227"></div>
                    </div>
                    <div data-id="element-228">
                      <strong className="block text-lg text-white mb-1" data-id="element-229">
                        BONO: {item.title}
                      </strong>
                      <span className="text-white/70 text-sm" data-id="element-230">{item.desc}</span>
                    </div>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}